import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { usersAdminStore } from '../admin/modules/UsersAdmin';
import { DashboardStore } from '../dashboard';

interface ICurrentUser {
  auth_id: number;
  Email: string;
  SessionKey: string | null;
  FirstName: string;
  LastName: string;
  Image: string;
  Phone: string;
  DeletedAt?: string | null;
  Verified: number;
  Address: string;
  City: string;
  State: string;
  Zip: string;
  Verification: string;
  PortalDeletedAt?: string | null;
  Companies: any[];
  Sites: any[];
  Apps: IUserAppInfo[];
  portal_role_id: number;
  ViewingRole: number;
  PermissionsList: any[];universityAccess
  IntroCoursesComplete:any; // E-001 TMPS > 2 Step Verification
  Log_Out_Time: number; //E-048

}

interface IUserAppInfo {
  app_id: number;
  App: string;
  Active: boolean;
  roles: any[],
  deletedRoles: any[]
}

class AuthStore {
  @computed
  public get sessionIsValid(): boolean {
    return !!this.currentUser.SessionKey;
  }


  @observable
  public currentUser: ICurrentUser = {} as ICurrentUser;

  @observable
  public loaded?: boolean = false;

  constructor() {
    this.currentUser.SessionKey = localStorage.getItem("token");
    if (!!this.currentUser.SessionKey) {
      this.loadUser(this.currentUser.SessionKey);
    }
  }

  @action
  public login = async (response: any) => {
    this.loaded = false;
    this.currentUser = { ...response }
    localStorage.setItem("token", response.SessionKey);
    localStorage.setItem("userdata", `${this.currentUser.Log_Out_Time}`); // E-048

    this.loaded = true;
  }

  @action
  public logout = async (auth_id: any) => {
    await this.removeSessionToken(auth_id)
    this.currentUser.SessionKey = null;
    localStorage.removeItem("token");
    this.loaded = false;
    usersAdminStore.loaded = false;
    this.currentUser = {} as ICurrentUser;
    DashboardStore.clearDashboard();
  }

  @action
  public removeSessionToken = async (auth_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/reset_token",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id
        }),
      }
    );
    return true
  }

  @action
  public toggleActiveCompany = async (auth_id: number, company_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/toggle_active_company",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id, company_id
        })
      }
    );
    const result = await response.json();
    if (result.body) {
      window.location.reload()
    }
  }

  @action
  public toggleActiveSite = async (auth_id: number, siteId: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/toggle_active_site",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id, siteId
        })
      }
    );
    const result = await response.json();
    if (result.body) {
      window.location.reload()
    }
  }

  @action
  public toggleActiveRole = async (auth_id: number, role_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/toggle_active_role",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id, role_id
        })
      }
    );
    const result = await response.json();
    if (result.body) {
      window.location.reload()
    }
  }

  @action
  public requestPasswordToken = async (email: string) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/request_password_token",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          email
        }),
      }
    );
    const result = await response.json();
    console.log(result)
    return result.body
  }

  @action
  public checkPasswordResetTokenValid = async (token: string) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/check_password_reset_token_valid",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          token
        }),
      }
    );
    const result = await response.json();
    console.log(result)
    return result.body
  }

  @action
  public changePasswordFromToken = async (pass: string, token: string) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/change_password_from_token",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          token,
          pass
        }),
      }
    );
    const result = await response.json();
    console.log(result)
    return result.body
  }

  @action
  public recordAuthAppLogin = async (auth_id: number, app_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/record_app_login",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id, app_id
        })
      }
    );
    // const result = await response.json();
  }

  @action
  public authPasswordVerification = async (password: string) => {
    const auth_id = authStore.currentUser.auth_id;
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/verify_password",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          password, auth_id
        }),
      }
    );
    const result = await response.json();
    if (result.success) {
      this.currentUser = result.body
      return { success: true, IntroCoursesComplete: result.body.IntroCoursesComplete,universityAccess:result.body.Apps }
    }
    return { success: false, IntroCoursesComplete: 0 }

  };

  @action
  public saveUserProfile = async (auth_id: number, authInfo: any) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/update_profile",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          auth_id, authInfo
        }),
      }
    );
    const result = await response.json();
    this.currentUser = { ...this.currentUser, ...authInfo }
  };

  @action
  private loadUser = async (SessionKey: string) => {
    console.log("SessionKey",SessionKey)
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/verify",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          SessionKey,
        }),
      }
    );
    const result = await response.json();
    this.login(await result.body);
    await DashboardStore.getDashboardLayout(result.body.auth_id)
    this.loaded = true;
  };
}
export const authStore = new AuthStore();

export const checkAuthStore = async () => {
  console.log(await authStore);
};



// WEBPACK FOOTER //
// ./src/modules/auth/store.ts